<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card>
            <v-card-title class="text-h5 text-center pa-4">Giriş Yap</v-card-title>
            <v-card-text>
               <v-alert v-if="error" type="error" dense dismissible class="mb-4">
                {{ error }}
              </v-alert>
               <v-alert v-if="registeredMessage" type="success" dense class="mb-4">
                 Kayıt başarılı! Lütfen giriş yapın.
               </v-alert>
  
              <v-form @submit.prevent="handleLogin" ref="loginForm">
                <v-text-field
                  v-model="emailOrUsername"
                  label="E-posta veya Kullanıcı Adı"
                  required
                  :rules="[rules.required]"
                  prepend-icon="mdi-account"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="Şifre"
                  type="password"
                  required
                  :rules="[rules.required]"
                  prepend-icon="mdi-lock"
                ></v-text-field>
                <v-btn
                  type="submit"
                  color="primary"
                  block
                  large
                  class="mt-4"
                  :loading="isLoading"
                  :disabled="isLoading"
                >
                  Giriş Yap
                </v-btn>
              </v-form>
  
               <v-divider class="my-4"></v-divider>
  
               <v-btn
                 color="red"
                 dark
                 block
                 large
                 :href="googleLoginUrl"
                 class="mt-2"
               >
                 <v-icon left>mdi-google</v-icon>
                 Google ile Giriş Yap
               </v-btn>
  
            </v-card-text>
             <v-card-actions class="justify-center pb-4">
                  Hesabınız yok mu? <v-btn small text color="primary" to="/register" class="pl-1">Kayıt Olun</v-btn>
              </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  
  export default {
    name: 'LoginView',
    data() {
      return {
        emailOrUsername: '',
        password: '',
        rules: {
          required: value => !!value || 'Bu alan zorunludur.',
        },
        registeredMessage: false, // Kayıt sonrası mesajı için
      };
    },
    computed: {
      ...mapGetters(['isLoading', 'error']), // Global loading ve error state'i
       googleLoginUrl() {
          // Backend'deki Google giriş başlatma URL'si
          const backendBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:5001/api';
          return `${backendBaseUrl}/auth/google`;
      }
    },
     mounted() {
      // Eğer ?registered=true query'si varsa mesajı göster
      if (this.$route.query.registered === 'true') {
        this.registeredMessage = true;
      }
       // Hata varsa temizle (başka sayfadan gelinmiş olabilir)
       this.$store.commit('CLEAR_ERROR');
    },
    methods: {
      ...mapActions('auth', ['login']), // Vuex login action'ını map et
      async handleLogin() {
         this.$store.commit('CLEAR_ERROR'); // Önceki hatayı temizle
        const { valid } = await this.$refs.loginForm.validate(); // Formu doğrula
        if (valid) {
           try {
             await this.login({
               emailOrUsername: this.emailOrUsername,
               password: this.password,
             });
             // Giriş başarılı olursa action içindeki router.push yönlendirecek
           } catch (err) {
             // Hata mesajı zaten Vuex store'da set edildi, burada ek bir şey yapmaya gerek yok
             // İsterseniz burada özel bir loglama yapabilirsiniz.
             console.error("Login component error:", err);
           }
        }
      },
    },
  };
  </script>